// extracted by mini-css-extract-plugin
module.exports = {"inner_list":"scrollbars_inner_list__2QSvr","view":"scrollbars_view__3acKP"};